import React from 'react';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { CheckIcon, SearchIcon, ViewIcon, CopyIcon } from '@chakra-ui/icons';
import SectionCard from './SectionCard';

/** "Check-in" tab: Présence (Présents / Attendus count), Check-in (manual + QR scanner), VIP Board (open + copy). */
const CheckinTab: React.FC<{
  present: number;
  expected: number;
  onManual: () => void;
  onScanner: () => void;
  vipBoardUrl: string | null;
  onCopyVipBoard: () => void;
}> = ({ present, expected, onManual, onScanner, vipBoardUrl, onCopyVipBoard }) => (
  <VStack align="stretch" spacing={4} data-testid="checkin-tab">
    <SectionCard title="Présence">
      <Text fontSize="sm" color="gray.600">Présents / Attendus</Text>
      <Text fontSize="2xl" fontWeight="bold" data-testid="checkin-count">
        Présents {present} / Attendus {expected}
      </Text>
    </SectionCard>
    <SectionCard title="Check-in">
      <HStack spacing={2} flexWrap="wrap">
        <Button leftIcon={<CheckIcon />} colorScheme="purple" onClick={onManual} data-testid="checkin-manual">
          Check-in manuel
        </Button>
        <Button leftIcon={<SearchIcon />} colorScheme="purple" variant="outline" onClick={onScanner} data-testid="checkin-scanner">
          Scanner QR
        </Button>
      </HStack>
    </SectionCard>
    {vipBoardUrl && (
      <SectionCard title="VIP Board">
        <HStack spacing={2} flexWrap="wrap">
          <Button
            as="a"
            href={vipBoardUrl}
            target="_blank"
            rel="noopener noreferrer"
            leftIcon={<ViewIcon />}
            variant="outline"
            data-testid="checkin-vip-open"
          >
            Ouvrir le VIP Board
          </Button>
          <Button leftIcon={<CopyIcon />} variant="outline" onClick={onCopyVipBoard} data-testid="checkin-vip-copy">
            Copier le lien VIP Board
          </Button>
        </HStack>
      </SectionCard>
    )}
  </VStack>
);

export default CheckinTab;
